import { Form } from 'formik'
import { Tooltip } from 'react-bootstrap'
import styled from 'styled-components'

import { BlueGradientButton } from 'components/common/atoms'

interface BtnWithTooltipWrapperProps {
  isDisabled: boolean
}

export const ContinueButton = styled(BlueGradientButton)`
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`

export const ScheduleTourFormStyled = styled(Form)`
  ${ContinueButton} {
    width: 100%;
  }

  & > div {
    margin-bottom: 8px;
  }

  @media (max-width: 991px) {
    ${ContinueButton} {
      margin: 24px 0 0 0;
    }

    & > div {
      margin: 0 0 16px;
    }
  }
`

export const BtnWithTooltipWrapper = styled.div<BtnWithTooltipWrapperProps>`
  display: inline-block;
  height: auto;
  width: 100%;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};

  @media (max-width: 991px) {
    display: block;
  }
`

export const MessageInputSection = styled.div`
  margin-bottom: 32px !important;

  @media (max-width: 991px) {
    margin-bottom: 24px !important;
  }
`

export const TooltipStyled = styled(Tooltip)`
  .tooltip-arrow {
    display: none !important;
  }
  .tooltip-inner {
    padding: 16px !important ;
    font-weight: 400 !important ;
    font-size: 14px !important ;
    line-height: 24px !important ;
    min-width: max-content !important ;
    inset: auto auto -10px 0px !important ;
    position: relative !important ;
  }
`
